import {css} from 'styled-components';
import logoImg from '../icons/slc/slc-logo-donatieform.svg';
import progress1 from '../icons/slc/step-indicator-1.svg';
import progress2 from '../icons/slc/step-indicator-2.svg';
import progress3 from '../icons/slc/step-indicator-3.svg';
import progress1of2 from '../icons/slc/step-indicator-1of2.svg';
import progress2of2 from '../icons/slc/step-indicator-2of2.svg';

import whatsapp from '../icons/sho/whatsapp.png';
import facebook from '../icons/sho/facebook.svg';
import linkedin from '../icons/sho/linkedin.svg';
import instagram from '../icons/sho/instagram.svg';
import twitter from '../icons/sho/x.svg';

const palette = {
  black: '#000000',
  darkInk: '#323230',
  darkGrey: '#888591',
  greyShade: '#CCCCCC',
  grey: '#EEEEEE',
  lightGrey: '#E2EAEA',
  white: '#FFFFFF',
  salmon: '#FF7861',
  salmonDark: '#DD5649',
  salmonSoft: '#FFE9E5',
  cyan: '#016667',
  lightGreen: '#088b7d',
  green: '#195c4b',
  darkGreen: '#134034',
  darkBlue: '#2E2A3D',
  softYellow: '#FAF5E6',

  selected: '#559760',
  selectedSoft: '#F3FAF6',
  error: '#EC407A',
  errorHard: '#E8141E',
  errorSoft: '#FFE5E6'
};

const defaultFont = '"Poppins", "Arial", "Verdana", "sans-serif"';
const thinFont = '"Figtree", "Arial", "Verdana", "sans-serif"';
const inputBorderStyle = {
  border: `1px solid ${palette.cyan}`,
  borderHover: `2px solid ${palette.cyan}`,
  borderValid: `1px solid ${palette.cyan}`,
  borderFocus: `2px solid ${palette.black}`,
  borderDisabled: `1px solid ${palette.lightGrey}`,
  borderError: `2px solid ${palette.error}`
};

export default {
  hideGenderTaxDeductible: true,
  // GlobalStyles
  bodyFontSize: '16px',
  h1FontSize: '26px',
  bodyFontFamily: defaultFont,
  h1FontFamily: defaultFont,
  h3FontFamily: defaultFont,
  backgroundColor: palette.darkGrey,
  linkHoverColor: palette.salmon,
  bodyFontColor: palette.darkInk,
  h1FontColor: palette.black,
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: cover;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
      background-position-y: top;
      background-position-x: left;
      background-attachment: local;
      left: -240px;
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      width: 100%;
      height: 100%;
      background-color: white;
      background-size: contain;
      background-position-y: top;
      background-position-x: center;
      background-repeat: no-repeat;
      inset: initial;
      z-index: -1;
      background-attachment: local;
      position: absolute;
    }
  `,
  donationBox: {
    imageAsBackground: true
  },

  smallHeader: true,
  horizontalField: {
    marginBottom: '-22px'
  },
  // AmountButton
  amountButton: {
    color: palette.white,
    colorHover: palette.white,
    inactiveColor: palette.darkInk,
    fontFamily: thinFont,
    fontSize: '20px',
    height: '52px',
    width: 'calc(50% - 7px)',
    ribbonHeight: '26%',
    ribbonTop: '74%',
    ribbonFont: defaultFont,
    ribbonFontWeight: 'normal',
    border: `2px solid ${palette.lightGreen}`,
    ribbonColor: palette.lightGreen,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.lightGreen,
    backgroundColorHover: palette.lightGreen,
    borderHover: `1px solid ${palette.lightGreen}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.lightGreen}`
  },
  frequencyButton: {
    color: palette.white,
    colorHover: palette.white,
    inactiveColor: palette.darkInk,
    fontFamily: thinFont,
    fontSize: '20px',
    height: '52px',
    width: 'calc(50% - 7px)',
    ribbonHeight: '26%',
    ribbonTop: '74%',
    ribbonFont: defaultFont,
    ribbonFontWeight: 'normal',
    border: `2px solid ${palette.lightGreen}`,
    ribbonColor: palette.lightGreen,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.lightGreen,
    backgroundColorHover: palette.lightGreen,
    borderHover: `1px solid ${palette.lightGreen}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.lightGreen}`
  },
  buttonContainerSpaceBetween: {
    width: '96px'
  },
  frequencyButtonContainer: {
    width: '96px'
  },
  //BackButton
  backButton: {
    fontSize: '16px',
    color: palette.darkInk
  },
  // Box
  boxComponent: {
    borderRadius: '12px',
    border: '0px'
  },
  // Button
  button: {
    borderRadius: '8px',
    fontFamily: defaultFont,
    fontSize: '20px',
    height: '52px',
    color: palette.black,
    backgroundColor: palette.salmon,
    active: css`
      background-color: ${palette.salmonDark};
      border-bottom: none;
      box-shadow: 0px 2px 0px 0px ${palette.black} !important;
    `,
    hover: css`
      background-color: ${palette.salmonDark};
      box-shadow: 0px 2px 0px 0px ${palette.black} !important;
    `,
    focus: css`
      background-color: ${palette.salmonDark};
      box-shadow: 0px 2px 0px 0px ${palette.black} !important;
    `
  },
  // Checkbox
  inputCheckbox: {
    label: {
      color: palette.darkInk,
      fontSize: '16px',
      display: 'block',
      lineHeight: '1.4em'
    },
    borderRadius: '4px',
    ...inputBorderStyle
  },
  box: {
    fontSize: '16px',
    colorHasError: palette.error,
    backgroundColorChecked: palette.lightGreen,
    backgroundBorderChecked: `1px solid ${palette.lightGreen}`,
    fillColorChecked: palette.white,
    borderHasError: `1px solid ${palette.error}`,
    ...inputBorderStyle
  },
  // DateInput
  dateDropdown: {
    padding: '15.6px 30px 12.4px 10px',
    borderRadius: '4px',
    boxShadowError: `0 0 0 1px ${palette.error}`,
    boxShadowValid: `0 0 0 1px ${palette.selected}`,
    height: 'auto',
    chevronTop: '16px',
    chevronSize: '20px',
    ...inputBorderStyle
  },
  // DisplayIban
  iban: {
    fontFamily: defaultFont,
    color: palette.white
  },
  // Dropdown
  dropdown: {
    color: palette.black,
    height: '46px',
    borderRadius: '8px',
    backgroundColor: palette.white,
    fontSize: '16px',
    chevronSize: '20px',
    paddingLeft: '13px',
    ...inputBorderStyle
  },
  // ErrorMessage
  error: {
    backgroundColor: palette.errorSoft,
    color: palette.error,
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    color: palette.black,
    fontSize: '16px',
    borderRadius: '4px',
    boxShadowFocus: 'none',
    colorPlaceholder: palette.greyShade,
    boxShadowValid: 'none',
    boxShadowError: 'none',
    colorError: palette.error,
    backgroundColorError: palette.errorSoft,
    ...inputBorderStyle
  },
  // TextArea
  textAreaComponent: {
    fontSize: '16px',
    border: '1px solid #c4c4c4',
    borderFocus: '1px solid #818181',
    boxShadowFocus: 'none',
    colorPlaceholder: '#c4c4c4',
    borderValid: `1px solid ${palette.black}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#F3FAF6',
    borderError: `1px solid ${palette.error}`,
    boxShadowError: 'none',
    colorError: palette.error,
    backgroundColorError: palette.errorSoft
  },
  // Label
  optionalLabel: {
    color: palette.darkInk,
    display: 'none'
  },
  requiredLabel: {
    color: palette.darkInk,
    display: 'inline'
  },
  label: {
    fontSize: '16px',
    color: palette.darkInk,
    colorError: palette.error
  },
  logo: {
    width: '212px',
    height: '80px',
    backgroundImage: logoImg,
    widthMobile: '126px',
    heightMobile: '48px',
    margin: '0',
    marginMobile: '0',
    container: {
      left: '0',
      top: '0',
      position: 'absolute'
    }
  },
  // PaymentButton
  paymentButton: {
    color: palette.white,
    colorHover: palette.white,
    inactiveColor: palette.darkInk,
    fontWeightActive: 'normal',
    fontFamily: defaultFont,
    fontSize: '16px',
    height: '78px',
    lineHeight: '78px',
    border: `2px solid ${palette.grey}`,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.lightGreen,
    backgroundColorHover: palette.lightGreen,
    borderHover: `2px solid ${palette.lightGreen}`,
    width: 'calc(50% - 7px)',
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.lightGreen}`
  },
  // RadioButton
  inputRadioButton: {
    fontSize: '14px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.white,
    borderActive: `4px solid ${palette.cyan}`,
    fillColor: 'transparent',
    color: palette.darkInk,
    ...inputBorderStyle
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 70px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 70px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  radio: {
    colorHasError: palette.error,
    borderHasError: `1px solid ${palette.error}`,
    ...inputBorderStyle
  },
  // TeaserHeader
  teaser: {
    display: 'inline',
    fontFamily: defaultFont,
    fontWeight: 'bold',
    fontSize: '28px',
    subtitleFontFamily: defaultFont,
    lineHeight: '47px',
    backgroundColor: palette.cyan,
    backgroundColorSubtitle: palette.cyan,
    color: palette.white,
    colorSubtitle: palette.white,
    padding: '3px 5px',
    fontSizeTablet: '28px',
    lineHeightTablet: '47px',
    fontSizeWide: '28px',
    lineHeightWide: '47px',
    subtitleFontSize: '16px',
    subtitleLineHeight: '31px',
    subtitleFontSizeWide: '16px',
    subtitleLineHeightWide: '31px',
    subtitleFontSizeTablet: '16px',
    subtitleLineHeightTablet: '31px',
    mobilePaddingTop: '20px',
    paddingTop: '0',
    // paddingTopSubtitle: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'left',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'left',
    noMarginTop: true
  },
  // Title
  title: {
    color: palette.white,
    fontFamily: defaultFont,
    fontSize: '20px',
    height: '65px',
    fontWeight: 'normal',
    borderRadius: '8px',
    backgroundColor: palette.cyan
  },
  // Validation
  validation: {
    color: palette.error,
    fontSize: '15px'
  },
  // OptIn
  optInButton: {
    fontFamily: defaultFont,
    fontSize: '20px',
    backgroundColor: palette.black,
    color: palette.black,
    boxShadow: 'none',
    active: css`
      background-color: ${palette.black};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${palette.black};
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: palette.black,
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  gridTemplateRows: '110px auto 1fr auto',
  gridTemplateColumns: 'minmax(40px, 4fr) 400px fit-content(400px) minmax(0px, 400px) 2fr',
  tabletGridTemplateRows: '240px auto 1fr auto',
  tabletGridTemplateColumns: '1fr 380px 1fr',
  tabletGridTemplateAreasCollecting: '". header ." ". sidebar ." ". content ." "footer footer footer"',
  mobileGridTemplateRows: '240px auto 1fr auto',
  mobileGridTemplateColumns: '1fr 380px 1fr',
  mobileGridTemplateAreasCollecting: '". header ." ". sidebar ." ". content ." "footer footer footer"'
};


